import { Checkbox as MuiCheckbox } from '@mui/material';
import { styled } from '@mui/material/styles';

const Checkbox = ({
  className,
  checked,
  mode = 'light',
  onChange,
  id,
  disabled,
  'aria-label': ariaLabel,
}: {
  className?: string;
  checked: boolean;
  mode?: 'light' | 'dark';
  onChange?: (checked: boolean) => void;
  id?: string;
  disabled?: boolean;
  'aria-label'?: string;
}) => {
  return (
    <StyledCheckbox
      id={id}
      className={className}
      checked={checked}
      disableRipple
      disabled={disabled}
      mode={mode}
      onChange={(e) => onChange?.(e.target.checked)}
      aria-label={ariaLabel}
    />
  );
};

const StyledCheckbox = styled(MuiCheckbox)<{
  mode: 'light' | 'dark';
}>(({ theme, mode }) => ({
  color:
    mode === 'light' ? theme.palette.grey500 : theme.palette.white,
  padding: `0 ${theme.spacing(1)} 0 0`,

  '&.Mui-checked': {
    color:
      mode === 'light'
        ? theme.palette.primary.main
        : theme.palette.red400,
  },
}));

export default Checkbox;
